import { useSyncExternalStore } from "react";
import { API_URL } from "../config";

// The number of unread notifications, shared by the bell in the header, the
// side menu and the Notifications page.

let count = 0;
const listeners = new Set();

export const setUnread = (value) => {
    const next = Number(value) || 0;
    if (next === count) return;

    count = next;
    listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

/** The current unread count; the component re-renders when it changes. */
export const useUnread = () => useSyncExternalStore(subscribe, () => count);

// The API is asked at most once in this many milliseconds, however often the
// window is looked at again, and never while the tab is hidden.
const MIN_GAP = 45000;
let lastAsked = 0;

/** Asks the API for the latest count. Quiet on failure: the old count stays. */
export const loadUnread = () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    if (typeof document !== "undefined" && document.hidden) return;

    const now = Date.now();
    if (now - lastAsked < MIN_GAP) return;
    lastAsked = now;

    fetch(`${API_URL}/notifications/unread-count`, {
        headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
    })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
            if (data) setUnread(data.unread_count);
        })
        .catch(() => {});
};
